import { WorkOrderStatusEnum } from 'gql/graphql';
import type { TableColumn } from 'uikit';

import { useMemo } from 'react';

export const useAdditionalBaseCols = (
    control: () => JSX.Element,
    workOrderStatus?: WorkOrderStatusEnum,
): TableColumn<any>[] =>
    useMemo(() => {
        if (workOrderStatus === WorkOrderStatusEnum.Completed || workOrderStatus === WorkOrderStatusEnum.InProgress) {
            return [
                {
                    id: 'Completed',
                    title: 'Выполнено по нз',
                    columns: [
                        {
                            title: 'Объем всего',
                            accessor: 'totalCompletedVolume',
                            align: 'right',
                            width: 112,
                        },
                        {
                            control,
                            title: '',
                            accessor: 'totalCompletedCost',
                            align: 'right',
                            width: 124,
                        },
                    ],
                },
                {
                    id: 'Remainder',
                    title: 'Остаток по нз',
                    columns: [
                        {
                            title: 'Объем всего',
                            accessor: 'totalRemainderVolume',
                            align: 'right',
                            width: 112,
                        },
                        {
                            control,
                            title: '',
                            accessor: 'totalRemainderCost',
                            align: 'right',
                            width: 124,
                        },
                    ],
                },
            ];
        }

        return [];
    }, [control, workOrderStatus]);
